<lx-price-lists-portal-table-header title="Private Lessons" [currency]="currency"></lx-price-lists-portal-table-header>
<p-table [value]="privateLessonsDataSource">
  <ng-template pTemplate="header">
    <tr>
      <th>Number of lessons</th>
      <th *ngFor="let label of privateLessonsTableLabels">{{ label }}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-data>
    <tr>
      <td>{{ data.numberOfLessons }}</td>
      <td *ngFor="let price of data.prices">{{ price | lxPrice : { defaultValue: '-' } }}</td>
    </tr>
  </ng-template>
</p-table>
<lx-price-lists-portal-notes *ngIf="notes?.length > 0" [notes]="notes" [notationMarks]="notationMarks" [company]="company"></lx-price-lists-portal-notes>
